/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {FileSummaryModel} from '../../api/ms-filemanager/contracts/file-summary.model';
import {AttachmentListSummaryModel} from '../../claim/shared/attachments-list-display/attachment-list-summary.model';

@Component({
    selector: 'app-file-list',
    templateUrl: './file-list.component.html',
    styleUrls: ['./file-list.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FileListComponent implements OnInit {

    @Input() files: AttachmentListSummaryModel[] = [];
    @Output() downloadClick = new EventEmitter<string>();

    constructor() {
    }

    ngOnInit(): void {
    }

    getExtension(file: FileSummaryModel): string {
        if (file == null || file.name.indexOf('.') < 0) {
            return '';
        }

        return file.name.split('.').pop();
    }

    convertBytesToKilobytes(bytes: number): number {
        return Math.round(bytes / 1024);
    }

    download(item: AttachmentListSummaryModel): void {
        if (!item.isDownloading) {
            this.downloadClick.emit(item.file.name);
        }
    }

}
